import { gql } from "apollo-boost";

export default gql`
  mutation ChangeUserPw($answers: [String]!, $feedbackID: String!) {
    sendFeedbackResult(answers: $answers, feedbackID: $feedbackID)
  }
`;
